import { render, staticRenderFns } from "./DownloadPaymentResume.vue?vue&type=template&id=6724c4c8"
import script from "./DownloadPaymentResume.vue?vue&type=script&lang=js"
export * from "./DownloadPaymentResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports